import axiosInstance from '../../lib/axios';
import { cancellableGet } from '../../lib/cancellableGet';

/** Sleep coach administration. Admin-only, TeamMember ids - see CLAUDE.md. */
const ROOT = '/admin/sleep-coach';

// Paginated envelope. status: pending | approved | rejected; omit for all.
// customerId narrows to one customer - the only way to read their reassignment history.
export const fetchCoachReassignments = ({ status, page = 1, limit = 50, customerId } = {}) => {
  const params = { page, limit };
  if (status) params.status = status;
  if (customerId) params.customer_id = customerId;
  return cancellableGet(`${ROOT}/coach-reassignments/`, { params });
};

// Bare object. 'manual' carries the chosen coach, 'auto' must not carry one at all.
// A 4xx leaves the request pending, so the id can be retried.
export const decideCoachReassignment = async (requestId, { status, mode, coachId, remark }) => {
  const body = { status };
  if (status === 'approved') {
    body.mode = mode;
    if (mode === 'manual') body.coach_id = coachId;
  }
  if (remark) body.remark = remark;
  const response = await axiosInstance.patch(`${ROOT}/coach-reassignments/${requestId}/`, body);
  return response.data;
};

// Direct reassignment: 'manual' carries a coach; 'auto' lets the server pick and must not.
export const setCustomerCoach = async (customerId, { mode, coachId, remark } = {}) => {
  const body = { mode };
  if (mode === 'manual') body.coach_id = coachId;
  if (remark) body.remark = remark;
  const response = await axiosInstance.patch(`${ROOT}/customers/${customerId}/coach/`, body);
  return response.data;
};
